import React from "react";

// Circular countdown ring shown next to the question during the answer
// sub-phase. Color steps green → amber → red and pulses under 3s,
// mirroring the speed-scoring window the athlete is racing against.
export default function CircularTimer({ msLeft, msTotal }: { msLeft: number; msTotal: number }) {
  const r = 22;
  const circ = 2 * Math.PI * r;
  const frac = msTotal > 0 ? Math.max(0, Math.min(1, msLeft / msTotal)) : 0;
  const warn = msLeft < 3000;
  const mid = msLeft < msTotal * 0.5;
  const stroke = warn ? "#ef4444" : mid ? "#f59e0b" : "#10b981";
  return (
    <div className={`relative w-14 h-14 shrink-0 ${warn ? "animate-pulse" : ""}`}>
      <svg width="56" height="56" viewBox="0 0 56 56" className="-rotate-90">
        <circle cx="28" cy="28" r={r} fill="none" stroke="#e9eef5" strokeWidth="5" />
        <circle
          cx="28"
          cy="28"
          r={r}
          fill="none"
          stroke={stroke}
          strokeWidth="5"
          strokeLinecap="round"
          strokeDasharray={circ}
          strokeDashoffset={circ * (1 - frac)}
          style={{ transition: "stroke-dashoffset 0.1s linear, stroke 0.3s" }}
        />
      </svg>
      <div
        className="absolute inset-0 grid place-items-center text-[15px] font-extrabold tabular-nums"
        style={{ color: stroke }}
      >
        {Math.ceil(msLeft / 1000)}
      </div>
    </div>
  );
}
